export default __webpack_public_path__ + "media/vendors/app_store_download-cfda97e9.svg";